@if (facade.dynamizationValues$ | async; as dynamizationValues) {
  @if (dynamizationValues.length) {
    <div class="row mb-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <web-design-system-switch
          data-zid="dynamic-toggle"
          [checked]="!!(facade.dynamization$ | async)"
          (checkedChange)="facade.handleDynamizationToggle()"
        >
          <div class="zero-text default p-base-reg">
            {{ 'savings-plan.savings-plan-form.dynamic.label' | transloco }}
            <sup (click)="openDynamizationInfo()" class="cursor-pointer">
              <web-design-system-icon name="info" size="small" />
            </sup>
          </div>
          <div class="zero-text disabled p-small-reg">{{ 'savings-plan.savings-plan-form.dynamic.label-hint' | transloco }}</div>
        </web-design-system-switch>
        @if (facade.dynamization$ | async) {
          <div class="d-flex gap">
            @for (value of dynamizationValues; track $index) {
              <web-design-system-toggle-switch
                data-zid="savingsplan-dynamic"
                [label]="(value | number: '1.0-2') + ' %'"
                [state]="(facade.dynamization$ | async) === value ? 'filled' : 'default'"
                (click)="facade.setDynamization(value)"
              />
            }
          </div>
        }
      </div>
    </div>
  }
}

<ng-template #dynamizationInfo let-modal>
  <web-design-system-modal (dismiss)="modal.dismiss()">
    <div class="zero-text p-base-reg">{{ 'savings-plan.savings-plan-form.dynamic.modal' | transloco }}</div>
  </web-design-system-modal>
</ng-template>
